import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import React, { useEffect, useRef } from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { getCookie } from 'cookies-next';

const Dashboard = () => {
  const dashboardRef = useRef(null);
  const sdkRef = useRef(null);
  const dashboardInstance = useRef(null);

  const token = getCookie("accessToken");

  const { dashboardId, dashboardUrl, loading, error } = useSelector((state) => state.config);

  useEffect(() => {
    if (!dashboardId || !dashboardUrl || !token) return;

    const sdk = new ChartsEmbedSDK({
      baseUrl: dashboardUrl,
      getUserToken: () => token
    });

    sdkRef.current = sdk;

    const initDashboard = async() => {
      try {
        const dashboard = sdk.createDashboard({ dashboardId });
        dashboardInstance.current = dashboard;

        if (dashboardRef.current) {
          await dashboard.render(dashboardRef.current);
          setTimeout(() => dashboard.refresh(), 5000);
        } else {
          throw new Error('Dashboard container not found');
        }
      } catch (err) {
        console.error("Dashboard initialization failed:", err);
      }
    };

    initDashboard();

    return () => {
      dashboardInstance.current?.destroy?.();
      sdkRef.current = null;
      dashboardInstance.current = null;
    };
  }, [dashboardId, dashboardUrl, token]);

  return (
    <div>
      {error && (
        <div style={{ color: "red", marginBottom: "10px" }}>Error: {error}</div>
      )}

      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" />
        </div>
      )}

      <div
        id="dashboard"
        ref={dashboardRef}
        style={{
          display: loading ? "none" : "block",
          width: "100%",
          height: "80vh",
          overflow: "hidden",
        }}
      />
    </div>
  );
};

export default Dashboard;
